var t, s;
function i() {
  if (s) return t;
  s = 1;
  return t = class {
    constructor(t, s, i, e, r, a, h, o, u, n, c, d, m, f) {
      this.street = t, this.street2 = s, this.secondary = i, this.city = e, this.state = r, this.zipCode = a, this.lastLine = h, this.addressee = o, this.urbanization = u, this.match = n, this.maxCandidates = c, this.inputId = d, this.format = m, this.countySource = f, this.result = [], this.customParameters = {};
    }
    addCustomParameter(t, s) {
      this.customParameters[t] = s;
    }
  };
}
export { i as __require };